


























































































import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import { Categoria, Pageable } from '@/models'
import { Fragment } from 'vue-fragment'
import { VListItemContent } from 'vuetify/lib'
import axios, { CancelTokenSource } from 'axios'
import { FindCategoriaUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component({
	components: {
		Fragment,
		VListItemContent,
	},
})
export default class DialogoSeletorDeCategorias extends Vue  {
	@PropSync('value') selecionados!: Categoria[] | null
	@Prop({ type: Function }) to?: (categoria: Categoria) => void
	@Prop() encurtado!: boolean
	categoria: Categoria | null = null
	mostra = false
	cancelToken: CancelTokenSource | null = null
	carregando = false
	busca = ''
	categorias: Categoria[] = []
	categoriasSelecionadasNaTela: string[] = []
	page: Pageable = {
		page: 1,
		size: 10,
		sort: [],
	}
	totalPages = 1
	categoriasSelecionadas: Categoria[] = []
	mudouPagina = false

	findCategoriaUseCase = new FindCategoriaUseCase()

	@Watch('categoria')
	onChangeCategoria(categoria: Categoria | null){
		if (!categoria) return
		this.$emit('input', categoria)
		this.mostra = false
		this.$nextTick(() => {
			this.categoria = null
		})
	}

	@Watch('busca')
	async onChangeBusca() {
		this.categorias = []
		this.page.page = 1
		this.categoriasSelecionadas = []
		const categoriasDaPagina = await this.findCategorias()
		this.atualizarSelecaoItensDaTela(categoriasDaPagina)
	}

	@Watch('page', { deep: true, immediate: true })
	async onChangePageable() {
		this.mudouPagina = true
		this.categorias = []
		const categoriasDaPagina = await this.findCategorias()
		this.atualizarSelecaoItensDaTela(categoriasDaPagina)
	}

	atualizarSelecaoItensDaTela(categoriasDaPagina: Categoria[] | undefined) {
		const categoriasSelecionadasDaPagina = categoriasDaPagina ?
			this.categoriasSelecionadas.filter(categoriaSelecionada => categoriasDaPagina.map(categoriaDaPagina => categoriaDaPagina.id).includes(categoriaSelecionada.id))
			:
			[]

		if (categoriasDaPagina) {
			this.categoriasSelecionadasNaTela = categoriasSelecionadasDaPagina.map(categoria => categoria.id)
		}
	}

	@Watch('categoriasSelecionadasNaTela')
	onChangeSelecionados(selecaoAtual: string[], selecaoAnterior: string[]) {
		if (selecaoAtual && !this.mudouPagina) {
			if(selecaoAtual.length > selecaoAnterior.length) {
				const categoriasAdicionadas = selecaoAtual.filter(x => !selecaoAnterior.includes(x))
				categoriasAdicionadas.forEach(categoriaAdicionada => {
					if (!this.categoriasSelecionadas.map(categoria => categoria.id).includes(categoriaAdicionada)) {
						const categoriaIndex = this.categorias.findIndex(categoria => categoria.id === categoriaAdicionada)
						if (categoriaIndex >= 0) this.categoriasSelecionadas.push(this.categorias[categoriaIndex])
					}
				})
			}

			if(selecaoAnterior.length > selecaoAtual.length) {
				const categoriasRemovidas = selecaoAnterior.filter(x => !selecaoAtual.includes(x))
				categoriasRemovidas.forEach(categoriaRemovida => {
					this.categoriasSelecionadas = this.categoriasSelecionadas.filter(caregoriaSelecionada => caregoriaSelecionada.id !== categoriaRemovida)
				})
			}
		}

		if (this.mudouPagina) this.mudouPagina = false
	}

	@Watch('mostra')
	onChangeMostra() {
		if (this.mostra) this.findCategorias()
	}

	async created() {
		await this.findCategorias()
	}

	mounted() {
		this.mudouPagina = false
	}

	async findCategorias() {
		if (this.cancelToken) this.cancelToken.cancel()
		try {
			this.carregando = true

			this.cancelToken = axios.CancelToken.source()
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const categoriasPage = await this.findCategoriaUseCase.findAll(
				{
					page: this.page.page ? this.page.page - 1 : 0,
					size: 10,
					busca: this.busca || undefined,
				}, axiosConfig,
			)


			this.totalPages = categoriasPage.totalPages
			this.categorias = categoriasPage.content
			this.carregando = false

			return categoriasPage.content
		} catch (e) {
			if (axios.isCancel(e)) return
			AlertModule.setError(e)
		} finally {
			this.carregando = false
		}
	}

	async marcarTudo() {
		this.buscarTodasAsCategoriasPorFiltro()
	}

	async buscarTodasAsCategoriasPorFiltro() {
		if (this.cancelToken) this.cancelToken.cancel()
		try {
			this.totalPages = 1
			this.carregando = true

			this.cancelToken = axios.CancelToken.source()
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const categoriasEncontradas = await this.findCategoriaUseCase.buscarTodasAsCategoriasPorFiltro(
				{
					busca: this.busca || undefined,
				}, axiosConfig,
			)


			this.categorias = categoriasEncontradas
			this.carregando = false

			this.categoriasSelecionadas = categoriasEncontradas
			this.atualizarSelecaoItensDaTela(categoriasEncontradas)
		} catch (e) {
			if (axios.isCancel(e)) return
			AlertModule.setError(e)
		} finally {
			this.carregando = false
		}
	}

	fechar() {
		this.mostra = false
		this.categorias = []
		this.page.page = 1
		this.categoriasSelecionadas = []
		this.categoriasSelecionadasNaTela = []
	}

	async confirmar() {
		this.$emit('setarCategorias', this.categoriasSelecionadas)
		this.mostra = false
	}
}

